<template>
  <div>
    <van-row style="margin-top50px;background-color: white;">
      <form action="/">
        <van-search
          v-model="queryParams.htbh"
          show-action
          placeholder="请输入合同关键词或者编号"
          @search="onSearch"

        >
        <template #action>
              <div v-if="!loading" @click="onSearch">搜索</div>
            </template>
  </van-search>
      </form>
    </van-row>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
    <div style="margin-top: 10px;" v-for="item in list" :key="item.htbh"  >
        <van-cell  :title="item.htmc" />
            <van-cell  title="合同编号" :value="item.htbh"/>
             <van-cell  title="部门" :value="item.deptName"/>
              <van-cell  title="合作商" :value="item.hzdwmc"/>
              <van-cell  title="合同金额" :value="item.htje"/>
               <van-cell  title="结算金额" :value="item.jsje"/>
               <van-cell  title="开票金额"  :value="item.kpje"/>
               <van-cell v-show="checkPermi(['xm:sk:list'])"  title="回款金额"  :value="item.hkje"/>
               <van-cell  title="核销金额"  v-show="checkPermi(['xm:hx:list'])" :value="item.hxje"/>
               <van-cell  title="付款金额" v-show="checkPermi(['xm:hx:list'])"   :value="item.fkje"/>
               <van-button type="primary" block @click="xzht(item)">确认</van-button>
    </div>

    </van-list>

  </div>
</template>

<script>
import {xzXshtList} from '@/api/xm/xshttz.js'
import choice from '../../components/Dict/choice.vue'
export default {
  name: 'kpsq',
  components: {
    choice: choice
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      keywords: '',
      total: 0,
      queryParams: {
        pageNum: 0,
        pageSize: 10,

        htbh: null

      }
    }
  },
  // onLoad (option) {
  //   this.keywords = option.keywords
  // },
  created () {
    // const id  = this.$route.params && this.$route.params.bzId;
    console.log(this.$route)
    const words = this.$route.query && this.$route.query.keywords
    this.keywords = words
    this.queryParams.htbh = words
    this.getList()
  },
  activated () {

  },
  methods: {

    getList () {
      this.queryParams.pageNum += 1

      xzXshtList(this.queryParams).then(res => {
        // this.finished = false
        this.loading = false
        this.total = res.total
        console.log('查询数据', this.queryParams.pageNum, this.total)
        if (this.queryParams.pageNum * this.queryParams.pageSize > this.total) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
      })
    },
    xzht (ht) {
      this.$store.dispatch('setkpht', ht)
      this.$router.go(-1)
    },
    onSearch () {
      this.list = []
      this.queryParams.pageNum = 0
      this.loading = true
      this.finished = false
      this.getList()
    },
    onCancel () {
      this.keywords = null
    } }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/KaiPiao/xzhtlist.vue